export var CELL_STYLE;
(function (CELL_STYLE) {
    CELL_STYLE["TEXT"] = "t";
    CELL_STYLE["HEADER"] = "h";
    CELL_STYLE["SUBHEADER"] = "sh";
    CELL_STYLE["COEFFICIENT"] = "c";
    CELL_STYLE["COEFFICIENT_TEXT"] = "ct";
})(CELL_STYLE || (CELL_STYLE = {}));
export var CELL_ALIGN;
(function (CELL_ALIGN) {
    CELL_ALIGN["CENTER"] = "c";
    CELL_ALIGN["LEFT"] = "l";
    CELL_ALIGN["RIGHT"] = "r";
})(CELL_ALIGN || (CELL_ALIGN = {}));
export var COLUMN_WIDTH;
(function (COLUMN_WIDTH) {
    COLUMN_WIDTH["MEDIUM"] = "md";
    COLUMN_WIDTH["SMALL"] = "sm";
})(COLUMN_WIDTH || (COLUMN_WIDTH = {}));
export var SITE_TYPE;
(function (SITE_TYPE) {
    SITE_TYPE[SITE_TYPE["COM"] = 0] = "COM";
    SITE_TYPE[SITE_TYPE["CUPIS"] = 1] = "CUPIS";
})(SITE_TYPE || (SITE_TYPE = {}));
export var LOCK_STATE;
(function (LOCK_STATE) {
    LOCK_STATE[LOCK_STATE["UNBLOCKED"] = 0] = "UNBLOCKED";
    LOCK_STATE[LOCK_STATE["BLOCKED"] = 1] = "BLOCKED";
})(LOCK_STATE || (LOCK_STATE = {}));
export var STATE;
(function (STATE) {
    STATE[STATE["ENABLED"] = 1] = "ENABLED";
    STATE[STATE["DISABLED"] = 0] = "DISABLED";
})(STATE || (STATE = {}));
export var INFOGRAPHIC_INFO;
(function (INFOGRAPHIC_INFO) {
    INFOGRAPHIC_INFO[INFOGRAPHIC_INFO["AVAILABLE"] = 1] = "AVAILABLE";
    INFOGRAPHIC_INFO[INFOGRAPHIC_INFO["UNAVAILABLE"] = 0] = "UNAVAILABLE";
})(INFOGRAPHIC_INFO || (INFOGRAPHIC_INFO = {}));
export var CHANNEL_ACTION;
(function (CHANNEL_ACTION) {
    CHANNEL_ACTION[CHANNEL_ACTION["SUBSCRIBE"] = 0] = "SUBSCRIBE";
    CHANNEL_ACTION[CHANNEL_ACTION["UNSUBSCRIBE"] = 1] = "UNSUBSCRIBE";
})(CHANNEL_ACTION || (CHANNEL_ACTION = {}));
/** Способ сортировки */
export var SORT_BY;
(function (SORT_BY) {
    /** По алфавиту */
    SORT_BY[SORT_BY["ALPHABET"] = 1] = "ALPHABET";
    /** По приоритету */
    SORT_BY[SORT_BY["PRIORITY"] = 2] = "PRIORITY";
})(SORT_BY || (SORT_BY = {}));
export var DATA_TYPE_CODE;
(function (DATA_TYPE_CODE) {
    /** Фиктивная информация о матче, код 1. Только для тестовых целей/отладки.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_MATCH_INFO"] = 1] = "FALSE_MATCH_INFO";
    /** Фиктивная информация о балансе игрока, код 2. Только для тестовых целей/отладки.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_BALANCE_INFO"] = 2] = "FALSE_BALANCE_INFO";
    /** Фиктивная информация о рассчитанных ставках игрока, код 3. Только для тестовых целей/отладки. */
    DATA_TYPE_CODE[DATA_TYPE_CODE["FALSE_BETS_INFO"] = 3] = "FALSE_BETS_INFO";
    /** Информация о матче, код 4.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["MATCH_INFO"] = 4] = "MATCH_INFO";
    /** Баланс интернет игрока, код 5.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["BALANCE_INFO"] = 5] = "BALANCE_INFO";
    /** Количество нерасчитанных ставок интернет игрока, код 6.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["RAW_BETS_COUNT"] = 6] = "RAW_BETS_COUNT";
    /** Live-меню для сайта, полное, код 7.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MENU_DATA"] = 7] = "LIVE_MENU_DATA";
    /** Live-меню для мобильной версии, упрощённое, код 8.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MENU_MOBILE"] = 8] = "LIVE_MENU_MOBILE";
    /** Фильтр Live результатов, код 9.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_RESULTS_FILTER"] = 9] = "LIVE_RESULTS_FILTER";
    /** Live результаты, код 10.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_RESULTS"] = 10] = "LIVE_RESULTS";
    /** Табличная роспись Live матча для сайта, код 36 (см. Табличная роспись Live матча).*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_OUTCOMES_TABLE"] = 36] = "LIVE_OUTCOMES_TABLE";
    /** Табличная роспись Live матча для мобильной версии, код 12 (см. Табличная роспись Live матча).*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_OUTCOMES_TABLE_MOBILE"] = 12] = "LIVE_OUTCOMES_TABLE_MOBILE";
    /** Баланс ИРМ игрока, код 13.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["BALANCE_INFO_IRM"] = 13] = "BALANCE_INFO_IRM";
    /** Количество нерасчитанных ставок ИРМ игрока, код 14.*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["RAW_BETS_COUNT_IRM"] = 14] = "RAW_BETS_COUNT_IRM";
    /** Изменение данных интернет игрока, код 15. */
    DATA_TYPE_CODE[DATA_TYPE_CODE["UPDATING_INTERNET_PLAYER_DATA"] = 15] = "UPDATING_INTERNET_PLAYER_DATA";
    /** Live-матчи по спорту для мобильной версии, код 16 (см. MobileAppSportLiveMatches16.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_SPORT_MOBILE"] = 16] = "LIVE_MATCHES_BY_SPORT_MOBILE";
    /** Топ Live-матчи для мобильной версии, код 17 (см. MobileAppHotLiveMatches17.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_TOP_MOBILE"] = 17] = "LIVE_MATCHES_BY_TOP_MOBILE";
    /** Live-матчи с видео для мобильной версии, код 18 (см. MobileAppLiveMatchesWithVideo18.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_WITH_VIDEO_MOBILE"] = 18] = "LIVE_MATCHES_WITH_VIDEO_MOBILE";
    /** Live-матчи из избранного для мобильной версии, код 19 (см. MobileAppFavoriteLiveMatches19.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_FAVORITES_MOBILE"] = 19] = "LIVE_MATCHES_FAVORITES_MOBILE";
    /** Все Live-матчи для сайта, код 20 */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_ALL"] = 20] = "LIVE_MATCHES_ALL";
    /** Live-матчи по спорту для сайта, код 21 (см. WebSportLiveMatches21.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_SPORT"] = 21] = "LIVE_MATCHES_BY_SPORT";
    /** Live-матчи по чемпионату для сайта, код 22 (см. WebChampionshipLiveMatches22.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_CHAMPIONSHIP"] = 22] = "LIVE_MATCHES_BY_CHAMPIONSHIP";
    /** Топ Live-матчи для сайта, код 23 (см. WebHotLiveMatches23.ts) */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_BY_TOP"] = 23] = "LIVE_MATCHES_BY_TOP";
    /** Live-матчи с видео для сайта, код 24 (см. WebLiveMatchesWithVideo24.ts) */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_WITH_VIDEO"] = 24] = "LIVE_MATCHES_WITH_VIDEO";
    /** Live-матчи из избранного для сайта, код 25 (см. WebFavoriteLiveMatches25.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_MATCHES_FAVORITES"] = 25] = "LIVE_MATCHES_FAVORITES";
    /** Табличная роспись Prematch матча для мобильной версии, код 27 (см. PrematchMatchMobileTableLine27.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LINE_OUTCOMES_TABLE_MOBILE"] = 27] = "LINE_OUTCOMES_TABLE_MOBILE";
    /** Один Live матч для сайта, код 38 (см. DesktopLiveMatchesSingleMatch38.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["LIVE_SINGLE_MATCH"] = 38] = "LIVE_SINGLE_MATCH";
    /** Информация о ставках на продажу для интернет игрока, код 29 (см. InternetWagersForSell29.ts) */
    DATA_TYPE_CODE[DATA_TYPE_CODE["BETS_COUNT"] = 29] = "BETS_COUNT";
    /** Все prematch-матчи для сайта, код 31 (см. DesktopAllPrematchMatches31.ts)*/
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_ALL_MATCHES"] = 31] = "PREMATCH_ALL_MATCHES";
    /** Prematch-матчи по спорту для сайта, код 32 (см. DesktopSportPrematchMatches32.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_SPORT_MATCHES"] = 32] = "PREMATCH_SPORT_MATCHES";
    /** Информация об исходах для корзины для интернет игрока, код 65 (см. TerminalBetCartByBetType66.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["BET_CART"] = 65] = "BET_CART";
    DATA_TYPE_CODE[DATA_TYPE_CODE["BET_CART_IRM"] = 66] = "BET_CART_IRM";
    DATA_TYPE_CODE[DATA_TYPE_CODE["BET_CART_FEATURES"] = 67] = "BET_CART_FEATURES";
    /** Табличная доп. роспись Prematch матча для сайта, код 37 (см. PrematchMatchDesktopTableLine37.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_MATCH_TABLE"] = 37] = "PREMATCH_MATCH_TABLE";
    //Один Prematch матч для сайта
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_SINGLE_MATCH"] = 39] = "PREMATCH_SINGLE_MATCH";
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_MATCHES_MAIN_PAGE"] = 40] = "PREMATCH_MATCHES_MAIN_PAGE";
    /** Все популярные Prematch матчи для сайта, код 41 (см. DesktopAllPopularPrematchMatches41.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_ALL_POPULAR_MATCHES"] = 41] = "PREMATCH_ALL_POPULAR_MATCHES";
    /** Популярные Prematch матчи из одной группы популярного для сайта, код 43 (см. DesktopPopularGroupPrematchMatches43.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_POPULAR_GROUP"] = 43] = "PREMATCH_POPULAR_GROUP";
    /** Prematch-матчи по региону для сайта, код 50 (см. DesktopTournamentRegionPrematchMatches50.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_REGION_MATCHES"] = 50] = "PREMATCH_REGION_MATCHES";
    /** Prematch-матчи по доп. инфо турнира для сайта, код 52 */
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_TOURNAMENTS_MATCHES"] = 51] = "PREMATCH_TOURNAMENTS_MATCHES";
    /** Prematch-матчи по доп. инфо турнира для сайта, код 52 */
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_DOP_INFO"] = 52] = "PREMATCH_DOP_INFO";
    /** Prematch-матчи по доп. инфо региона для сайта */
    DATA_TYPE_CODE[DATA_TYPE_CODE["PREMATCH_REGION_DOP_INFO"] = 53] = "PREMATCH_REGION_DOP_INFO";
    /** Информация об инфографике 59 (см. InternetBetCart34.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["MATCH_INFOGRAPHICS"] = 59] = "MATCH_INFOGRAPHICS";
    /** Информация о серверном времени (см. InternetBetCart34.ts). */
    DATA_TYPE_CODE[DATA_TYPE_CODE["SERVER_TIMESTAMP"] = 60] = "SERVER_TIMESTAMP";
    /** Лайв матч чемпионата мира по футболу десктоп 2022 (см. InternetBetCart34.ts). */
    // DEPRECATED WORLD_CHAMPIONSHIP = 62,
    /** Евро 2024 таблицы итогов группового этапа. код 9. */
    DATA_TYPE_CODE[DATA_TYPE_CODE["EURO_2024_GROUP_STAGE_SUMMARY_TABLE"] = 9] = "EURO_2024_GROUP_STAGE_SUMMARY_TABLE";
    /** Евро 2024 таблицы итогов чемпионата. код 10. */
    DATA_TYPE_CODE[DATA_TYPE_CODE["EURO_2024_CHAMPIONSHIP_SUMMARY_TABLE"] = 10] = "EURO_2024_CHAMPIONSHIP_SUMMARY_TABLE";
    /** Евро 2024 сеткa группового этапа. код 62. */
    DATA_TYPE_CODE[DATA_TYPE_CODE["EURO_2024_GROUP_STAGE_GRID"] = 62] = "EURO_2024_GROUP_STAGE_GRID";
    /** Евро 2024 плейофф код 63. */
    DATA_TYPE_CODE[DATA_TYPE_CODE["EURO_2024_PLAYOFF"] = 63] = "EURO_2024_PLAYOFF";
    /* Счетчик ленты уведомлений */
    DATA_TYPE_CODE[DATA_TYPE_CODE["NOTIFICATION_COUNTER"] = 61] = "NOTIFICATION_COUNTER";
    /* Расширенный счет */
    DATA_TYPE_CODE[DATA_TYPE_CODE["EXTENDED_SCORE"] = 68] = "EXTENDED_SCORE";
})(DATA_TYPE_CODE || (DATA_TYPE_CODE = {}));



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/const/base.js